import IPlanEditor from './IPlanEditor';
import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { Button, ButtonToolbar } from 'react-bootstrap';
import ImpersonateButton from '../../components/ImpersonateButton';
import DeleteButton from '../../components/common/DeleteButton';
import TelephoneLink from '../../components/common/TelephoneLink';
import EmailLink from '../../components/common/EmailLink';

interface IPlanEditorListRowProps {
    planEditor: IPlanEditor;
    key: number;
    delete: (id: number) => void;
    triggerEdit: (id: number) => void;
}

const PlanEditorListRow = (props: IPlanEditorListRowProps) => {
    return (
        <tr>
            <td>{props.planEditor.name}</td>
            <td>{Translate(props.planEditor.role)}</td>
            <td>
                <EmailLink>{props.planEditor.email}</EmailLink>
            </td>
            <td>
                <TelephoneLink>{props.planEditor.phoneNumber}</TelephoneLink>
            </td>
            <td>{props.planEditor.planFirmName}</td>
            <td className="tools">
                <ButtonToolbar className="pull-right btn-group-sm">
                    <DeleteButton
                        onDelete={() => props.delete(props.planEditor.id)}
                        text={Translate('plan-editors/list/row/delete/remove-this-user')}
                    >
                        <i className="material-icons">delete</i>{' '}
                        {Translate('plan-editors/list/row/button-label/delete')}
                    </DeleteButton>
                    <Button
                        onClick={() => props.triggerEdit(props.planEditor.id)}
                        bsStyle="primary"
                    >
                        <i className="material-icons">edit</i>{' '}
                        {Translate('plan-editors/list/row/button-label/edit')}
                    </Button>
                    <ImpersonateButton userId={props.planEditor.id} />
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default PlanEditorListRow;
